import React from 'react';
import SEO from '../components/SEO';
import { SITE_URL, SITE_NAME, CONTACT_EMAIL } from '../config/site';
import './LegalPage.css';

const TermsOfServicePage = () => (
  <div className="legal-page">
    <SEO
      title={`Terms of Service | ${SITE_NAME}`}
      description="Terms of service for using the Dr. Muyabins Dental Care website."
      url={`${SITE_URL}/terms`}
    />
    <div className="legal-container">
      <h1>Terms of Service</h1>
      <p className="legal-updated">Last updated: June 12, 2026</p>

      <section>
        <h2>Acceptance of Terms</h2>
        <p>
          By accessing {SITE_URL}, you agree to these Terms of Service. If you do not agree,
          please do not use this website.
        </p>
      </section>

      <section>
        <h2>Use of the Website</h2>
        <p>
          This website provides information about dental services, allows appointment requests,
          and offers educational blog content. Information on this site is for general purposes
          and does not replace professional dental advice, diagnosis, or treatment.
        </p>
      </section>

      <section>
        <h2>Medical Disclaimer</h2>
        <p>
          Content on this website, including blog articles, is for educational purposes only.
          Always seek the advice of a qualified dentist or other healthcare provider with any
          questions regarding a medical condition. Never disregard professional medical advice
          because of something you have read on this website.
        </p>
      </section>

      <section>
        <h2>Appointments</h2>
        <p>
          Submitting an appointment request does not guarantee a confirmed appointment.
          Our team will contact you to confirm date, time, and availability.
        </p>
      </section>

      <section>
        <h2>Blog and Comments</h2>
        <p>
          Blog comments are moderated. We reserve the right to remove comments that are spam,
          offensive, or unrelated to the discussion. By submitting a comment, you grant us
          permission to display it on our website.
        </p>
      </section>

      <section>
        <h2>Advertising</h2>
        <p>
          Our blog may display advertisements served by Google AdSense. We are not responsible
          for the content of third-party advertisements. Your interaction with advertisers is
          solely between you and the advertiser.
        </p>
      </section>

      <section>
        <h2>Intellectual Property</h2>
        <p>
          All content on this website, including text, images, and logos, is owned by{' '}
          {SITE_NAME} unless otherwise stated. You may not reproduce content without written permission.
        </p>
      </section>

      <section>
        <h2>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, {SITE_NAME} shall not be liable for any
          indirect, incidental, or consequential damages arising from your use of this website.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          Questions about these terms? Email{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </section>
    </div>
  </div>
);

export default TermsOfServicePage;
